import QRCode from "qrcode.react";
import {
  Row,
  Column,
  ButtonGroup,
  CancelButton,
  Clue,
  Form,
  SubmitButton,
  TextInput,
} from "lcm-iot-commons";
import { Formik } from "formik";
import { useIntl } from "react-intl";

const allow6Numbers = /^\d{6}$/;

type OwnProps = {
  provisioningUri?: string;
  onSubmit: $TSFixMeFunction;
  initialValues?: {
    email?: string;
    password?: string;
  };
};

const defaultProps: Partial<OwnProps> = {
  provisioningUri: undefined,
  initialValues: {},
};

type Props = OwnProps & typeof defaultProps;

export default function MultiFactorAuthenticationForm({
  provisioningUri,
  onSubmit,
  initialValues,
}: Props) {
  const intl = useIntl();

  const validateForm = (values: $TSFixMe) => {
    const errors = {};
    if (!values.otpCodeToken) {
      (errors as $TSFixMe).otpCodeToken = intl.formatMessage({
        id: "mfa.code_mandatory",
      });
    } else if (!allow6Numbers.test(values.otpCodeToken)) {
      (errors as $TSFixMe).otpCodeToken = intl.formatMessage({
        id: "mfa.code_format",
      });
    }
    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;
    return (
      <Form {...formProps}>
        {provisioningUri ? (
          <Row>
            <Column md={4}>
              <QRCode value={provisioningUri} level="H" size={256} />
            </Column>
            <Column md={4}>
              <Clue
                id="mfg-qr-hint"
                details={intl.formatMessage({ id: "mfa.clue_details" })}
                highlighted
              />
            </Column>
          </Row>
        ) : null}
        <Row>
          <Column md={8}>
            <TextInput
              {...formProps}
              id="mfa-code"
              name="otpCodeToken"
              otpCodeToken
              label={intl.formatMessage({ id: "mfa.code" })}
              placeholder={intl.formatMessage({ id: "mfa.code_placeholder" })}
              required
            />
          </Column>
        </Row>
        <Row>
          <Column md={8}>
            {/* @ts-expect-error TS(2322) FIXME: Type '{ children: Element[]; className: string; }'... Remove this comment to see the full error message */}
            <ButtonGroup className="btn-group">
              <SubmitButton
                id="mfa-change-submit"
                text={
                  provisioningUri
                    ? intl.formatMessage({ id: "mfa.button_enable_action" })
                    : intl.formatMessage({ id: "mfa.button_disable_action" })
                }
                fetching={isSubmitting}
                disabled={!formProps.dirty}
              />
              <CancelButton
                id="mfa-change-cancel"
                // @ts-expect-error TS(2322) FIXME: Type '{ id: string; disabled: any; intl: IntlShape... Remove this comment to see the full error message
                disabled={isSubmitting}
                intl={intl}
              />
            </ButtonGroup>
          </Column>
        </Row>
      </Form>
    );
  };

  return (
    <Formik
      id="change-mfa-form"
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={validateForm}
    >
      {renderForm}
    </Formik>
  );
}

MultiFactorAuthenticationForm.defaultProps = defaultProps;
